import { Messages } from "../../lib/locale";

export const French: Messages = {
  name: "Français",
  helpTitle: "Comment jouer",
  help1: `Votre tâche est de découvrir quel pays est caché dans le jeu. Pour ce faire, vous devez entrer les noms de pays aléatoires. Écrivez le pays dans la zone de saisie et appuyez sur Entrée. Ce pays apparaîtra sur la carte et changera de couleur en fonction de sa proximité avec le pays caché. Plus la couleur est foncée, plus vous êtes proche de la réponse !`,
  help2: `Regardez l'exemple du jeu. Disons que le pays Japon est caché dans le jeu. Ensuite, ces pays seront peints dans de telles couleurs.`,
  help3: `Une fois par jour, un nouveau pays caché est disponible. Ou passez en mode gratuit dans les paramètres et jouez en illimité.`,
  France: "France",
  Nepal: "Népal",
  Mongolia: "Mongolie",
  "South Korea": "Corée du Sud",
  Aux1: `<b>["Cliquez", "Appuyez"]</b> sur le globe pour commencer!`,
  Loading: "Attendez-le...",
  GameTitle: "Jeu",
  Game1: "Entrez le nom du pays ici",
  Game2: "Entrer",
  Game3: "Tapez un nom de pays aléatoire et appuyez sur Entrée pour commencer",
  Game4: `Tournez, <span>["cliquez", "touchez"]</span> et zoomez sur le globe pour trouver le prochain pays à deviner`,
  Game5: "Nous ne connaissons pas ce pays",
  Game6: "Ce pays est déjà entré",
  Game7: "Le pays caché était la {answer}!",
  Game8: "Frontière la plus proche",
  StatsTitle: "Statistiques",
  Stats1: "Dernière victoire",
  Stats2: "Tentatives d'aujourd'hui",
  Stats3: "Jeux gagnés",
  Stats4: "Série actuelle",
  Stats5: "Série maximale",
  Stats6: "Suppositions moyennes",
  Stats7: "Moy. Suppositions",
  Stats8: "Réinitialiser",
  Stats9: "Partager",
  Stats10: "Voulez-vous vraiment réinitialiser votre score?",
  Stats11: "Statistiques effacées.",
  Stats12: "Copié dans le presse-papier!",
  SettingsTitle: "Réglages",
  Settings1: "Thème du jour",
  Settings2: "Thème de la nuit",
  Settings3: "Mode daltonien",
  Settings4: "Mode daltonien",
  Settings5: "Des pays",
  Settings7: "Langue",
  Settings9: "Mode libre",
  Settings10: "Allusion",
  Answer: "Réponse",
  Closest: "Le plus proche",
  Guessed: "Deviné",
  PracticeMode: "Vous êtes en mode libre.",
  PracticeExit: "Quitter le mode libre",
  PracticeNew: "Nouveau jeu gratuit",
  PlayAgain: "Rejouer",
  SortBy: "Trier par:",
  SortByGuesses: "ordre deviné",
  SortByDistance: "distance",
  Clipboard: "🌍🌍🌍\nJ'ai deviné le pays caché dans le Globle d'aujourd'hui en {X} suppositions\nPouvez-vous faire mieux?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "La victoire",
  Guesses: "Suppositions",
  GuessesFlags: "Vos suppositions seront ici",
  Daily: "Quotidien",
  NextDailyIn: "Prochain quotidien",
  Learn: "En savoir plus sur ce pays"
};